import { render, staticRenderFns } from "./OtherCommentSkeleton.vue?vue&type=template&id=7d0087aa"
import script from "./OtherCommentSkeleton.vue?vue&type=script&lang=js"
export * from "./OtherCommentSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports